<template>
  <div style="padding:20rem 640rem;">
    <div style="color:#3a7fb6;text-decoration: underline;font-size:20rem;padding-bottom:15rem;">公司地址:</div>
    <img style="display:block;width:640rem;" src="../assets/zsp/company_map.jpg">
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>